export const BLOCK_BORDER_COLOR = "#E2E8F0";
